var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRadioBlanki = function SvgRadioBlanki(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M12 21a9 9 0 1 0 0-18 9 9 0 1 0 0 18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#dfe2e5",
    d: "M12 21a9 9 0 1 0 0-18 9 9 0 1 0 0 18m0-1.4a7.6 7.6 0 1 1 0-15.2 7.6 7.6 0 1 1 0 15.2"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRadioBlanki);
export default ForwardRef;